import React from 'react';
import { SettingPage } from './SettingsPage';
import { Route } from 'react-router-dom';

export const routes = [<Route key="0" path="/settings" component={SettingPage} />];

export const navigation = { name: 'settings', link: '/settings', icon: 'Settings' };
